import ErrorBoundary from '../ErrorBoundary';
import { Outlet } from 'react-router-dom';
import Header from 'shared/layout/Header';

function DefaultLayout() {
  return (
    <>
      <Header />
      <main className="w-screen h-screen">
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </main>
    </>
  );
}

export default DefaultLayout;
